export default {
  data() {
    return {
      innerValue: null,
    }
  },
  computed: {
    showCharacterCounter() {
      return this.withCharacterCounter && this.hasMaxLength
    },
    hasMaxLength() {
      return this.$attrs.maxlength && this.$attrs.maxlength > 0
    },
    characterCount() {
      return this.innerValue ? this.innerValue.length : 0
    },
    countLabel() {
      return this.characterCount + ' / ' + this.$attrs.maxlength
    },
    maxlengthReached() {
      if (!this.hasMaxLength) return false
      const max = parseInt(this.$attrs.maxlength)
      return this.characterCount >= max
    },
  },
  methods: {
    handleInput(e) {
      this.innerValue = e.target.value
      this.$emit('input', e.target.value)
    },
  },
  beforeMount() {
    this.innerValue = this.value
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal
    },
  },
}
